import useSubscriptions from './useSubscriptions';
import apps from './apps';

export default () => {
  const defaultApps = ['iam'];
  const subscriptions = useSubscriptions();
  const items = subscriptions.map(subscription => subscription.code);
  const products = [...defaultApps, ...new Set(items)];

  return apps.filter(app => products.includes(app.key));
};
